/**
 * IMPORTS
 */

const ACCESS_TOKEN_KEY = "@letscom:token";
const REFRESH_TOKEN_KEY = "@letscom:refresh_token";
const USER = "@letscom:user";

/**
 * EXPORTS
 */
export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, USER };
